import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./ExaminationHome.css"; // Import custom CSS

const ExaminationHome = () => {
  const navigate = useNavigate(); // Hook to programmatically navigate

  const handleButtonClick = (exam_name) => {
    navigate(`/erp/examinations/${exam_name}`);
    // setTimeout(() => navigate(`/examinations/${examName}`), 0); // Navigate after state update
  };

  return (
    <>
      <div className="container mt-5 bg-gradient bg-success rounded p-5 mb-5">
        {/* Heading */}
        <h3 className="text-center text-white mb-5">Choose examination type</h3>

        <div className="row justify-content-center">
          {/* Button 1 */}
          <div className="col-md-3 mb-3">
            <button
              className="btn btn-common w-100"
              onClick={() => handleButtonClick("unit-test-1")}
            >
              Unit Test 1
            </button>
          </div>
          {/* Button 2 */}
          <div className="col-md-3 mb-3">
            <button
              className="btn btn-common w-100"
              onClick={() => handleButtonClick("terminal-1")}
            >
              Terminal 1
            </button>
          </div>
        </div>

        <div className="row justify-content-center">
          {/* Button 3 */}
          <div className="col-md-3 mb-3">
            <button
              className="btn btn-common w-100"
              onClick={() => handleButtonClick("unit-test-2")}
            >
              Unit Test 2
            </button>
          </div>
          {/* Button 4 */}
          <div className="col-md-3 mb-3">
            <button
              className="btn btn-common w-100"
              onClick={() => handleButtonClick("terminal-2")}
            >
              Terminal 2
            </button>
          </div>
        </div>

        <div className="row justify-content-center">
          {/* Button 5 */}
          <div className="col-md-3 mb-3">
            <button
              className="btn btn-common w-100"
              onClick={() => handleButtonClick("unit-test-3")}
            >
              Unit Test 3
            </button>
          </div>
          {/* Button 6 */}
          <div className="col-md-3 mb-3">
            <button
              className="btn btn-common w-100"
              onClick={() => handleButtonClick("terminal-3")}
            >
              Terminal 3
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ExaminationHome;
